module.exports = __webpack_public_path__ + "static/media/loading.69881ee8.svg";